'use strict';

const gigyaPostAuth = require('./utils/gigyaPostAuth');
const gigyaPageLoader = require('./utils/gigyaPageLoader');
const passwordRules = require('./utils/passwordRules');
const emailValidation = require('./utils/emailValidation');
const vatNumberValidation = require('./utils/vatNumberValidation');

// The login page is server-rendered first, then Gigya injects the actual UI.
// We keep the fullscreen loader active until Gigya confirms that the screen set
// is ready, so the shopper never sees the intermediate empty state.
function initLoginScreenSet() {
	const $container = $('#gigya-handle');
	const startPage = $container.data('startPage');

	if (!startPage || !window.gigya || !gigya.accounts) {
		return;
	}

	let sSetType;
	switch (String(startPage).toLowerCase()) {
		case 'register':
			sSetType = 'register';
			break;
		case 'org':
			sSetType = 'register-company';
			break;
		case 'forgot':
			sSetType = 'forgot-password';
			break;
		default:
			sSetType = 'login';
	}

	const authOptions = {
		postUrl: $container.data('action'),
		requireEventType: true
	};
	let activeGigyaScreen = '';
	let registrationFlowType = sSetType;
	let registrationAccountType = sSetType === 'register-company' ? 'b2b' : sSetType === 'register' ? 'b2c' : null;
	let passwordValidator = null;
	let emailValidator = null;
	let vatNumberValidator = null;

	function syncRegistrationContextFromScreen(screenId) {
		screenId = String(screenId || '').toLowerCase();

		if (screenId.indexOf('register-company') !== -1) {
			registrationFlowType = 'register-company';
			registrationAccountType = 'b2b';
			return;
		}

		if (screenId === 'gigya-register-screen') {
			registrationFlowType = 'register';
			registrationAccountType = 'b2c';
		}
	}

	function buildAuthContext() {
		return {
			registrationFlowType: registrationFlowType,
			registrationAccountType: registrationAccountType,
			activeScreen: activeGigyaScreen
		};
	}

	gigya.accounts.showScreenSet({
		screenSet: 'MainAurora-RegistrationLogin',
		startScreen: 'gigya-' + sSetType + '-screen',
		containerID: 'gigya-handle',
		lang: document.documentElement.lang,
		onAfterScreenLoad: function (eventObj) {
			gigyaPageLoader.setGigyaPageLoading(false);

			// Solo se l'inizio del form è fuori schermo (es. dopo un submit)
			if ($container.get(0).getBoundingClientRect().top < 0) {
				window.scrollTo({ top: 0, behavior: 'smooth' });
			}

			activeGigyaScreen = eventObj.currentScreen || eventObj.screen || activeGigyaScreen;
			syncRegistrationContextFromScreen(activeGigyaScreen);

			if (window.lavazzaGtm && window.lavazzaGtm.auth) {
				window.lavazzaGtm.auth.handleRegistrationScreenLoad(eventObj, buildAuthContext());
				window.lavazzaGtm.auth.handleForgotPasswordScreenLoad(eventObj);
			}

			if (eventObj.currentScreen === 'gigya-verification-sent-screen') {
				const $title = $('#gigya-handle').find('.lvz-gigya-title');

				if (!$title.length) return;
				// Business accounts: profile.firstName is empty and profile.lastName is the company name,
				// the contact person is in data (same mapping as gigyaHelpers.applyBusinessProfileFields).
				const profile = eventObj?.profile || {};
				const data = eventObj?.data || {};
				const profileName = data.contactPersonName || profile.firstName || profile.lastName || '';
				if (profileName) {
					$title.html($title.html().replace(/\{\{profile\.email\}\}/g, profileName));
				}
			}

			//Init custom select on Gigya
			const $context = $('#gigya-handle');
			const classesToMove = 'custom-select nice-select-lvz wide';

			$context.find('.gigya-composite-control-dropdown').each(function () {
				const $dropdown = $(this);
				const $select = $dropdown.find('select').first();

				if (!$select.length) {
					return;
				}

				$dropdown.removeClass(classesToMove);
				$select.addClass(classesToMove);
			});

			$(document).trigger('update:nice-select', { $context: $context });
			$(document).trigger('update:lvz-datepicker', { $context: $context });
			passwordValidator = passwordRules($context.get(0));
			emailValidator = emailValidation($context.get(0), activeGigyaScreen);
			vatNumberValidator = vatNumberValidation($context.get(0));
		},
		onBeforeSubmit: function () {
			let canSubmit = true;

			if (passwordValidator && !passwordValidator.isValid()) {
				passwordValidator.markTouched();
				canSubmit = false;
			}

			if (emailValidator && !emailValidator.isValid()) {
				emailValidator.markTouched();
				canSubmit = false;
			}

			if (vatNumberValidator && !vatNumberValidator.isValid()) {
				vatNumberValidator.markTouched();
				canSubmit = false;
			}

			return canSubmit;
		},
		onAfterSubmit: function (eventObj) {
			const response = eventObj.response || {};
			const eventType = (response.operation || eventObj.eventName || '').toLowerCase();
			const authContext = buildAuthContext();

			if (window.lavazzaGtm && window.lavazzaGtm.auth) {
				window.lavazzaGtm.auth.handleRegistrationAfterSubmit(eventObj, authContext);
				window.lavazzaGtm.auth.handleForgotPasswordAfterSubmit(eventObj, authContext);
			}

			if (eventObj.currentScreen || eventObj.screen) {
				activeGigyaScreen = eventObj.currentScreen || eventObj.screen;
			}

			if (eventType.indexOf('register') === -1) {
				return;
			}
			gigyaPostAuth.postGigyaAuth(eventObj, authOptions);
		}
	});
}

function onGigyaReady() {
	initLoginScreenSet();
}

$(document).ready(function () {
	if (!$('.login-page-container').length) {
		return;
	}

	gigyaPageLoader.setGigyaPageLoading(true);

	if (window.gigya && gigya.accounts) {
		onGigyaReady();
		return;
	}

	const previousReady = window.onGigyaServiceReady;
	window.onGigyaServiceReady = function () {
		if (typeof previousReady === 'function') {
			previousReady();
		}
		onGigyaReady();
	};
});
